export const deleteDuplicates = <T extends any>(arr: T[], eq: (a: T, b: T) => boolean) => {
    let dups = [] as T[]
    for (let x of arr) {
        if (!dups.some((y) => eq(x, y))) dups.push(x)
    }
    return dups
}
